import { Routes } from '@angular/router';
import { AuthComponent } from './auth/auth.component';

export const authRoutes: Routes = [
  {
    path: '',
    redirectTo: 'authenticate',
    pathMatch: 'full',
  },
  {
    path: 'authenticate',
    component: AuthComponent,
  },
];
